import { Grid, IconButton, Tooltip } from "@material-ui/core";
import AddToQueueIcon from "@material-ui/icons/AddToQueue";
import AssignmentIcon from "@material-ui/icons/Assignment";
import CancelPresentationIcon from "@material-ui/icons/CancelPresentation";
import CancelScheduleSendIcon from "@material-ui/icons/CancelScheduleSend";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import TableComponent from "app/common/Component/Table/TableComponent";
import IconDelete from "app/common/Icon/IconDelete";
import {
  LAServiceRequestItemStatusEnum,
  PathModule,
  SERVICE_REQUEST_STATUS,
  SERVICE_TREATMENT_TYPE_WARRANTY,
} from "app/common/LocalConst";
import {
  getAge,
  getDate,
  getDateTime,
  getGender,
  isAdmin,
  isDoctor,
  isRoleBranchManager,
  isRoleChiefTechician,
  isRoleHisReadOnly,
  isRoleTechician,
} from "app/common/LocalFunction";
import { getOrCreateNewByServiceRequestItemId } from "app/services/DiagnosticReportService";
import { useStore } from "app/stores";
import history from "history.js";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import CopyableCodeCell from "app/common/Component/CopyableCodeCell";
import Config from "../../appConfig";

const TreatmentListAllData = () => {
  const { t } = useTranslation();

  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  const isAdmins = isAdmin();
  const isRoleBranchManagers = isRoleBranchManager();
  const isReadonly = isRoleHisReadOnly();
  const isDoctors = isDoctor();
  const hasPermission =
    isRoleCt || isAdmins || isRoleBranchManagers || isReadonly || isDoctors;
  const {
    handleOpenAllocationServicePopup,
    handleDeleteNewServiceRequestItem,
  } = useStore().patientManagementStore.serviceRequestItemStore;

  const {
    pageTreatmentListAll,
    searchTreatmentListAll,
    handleChangeFormSearch,
    setSelectedRowTreatmentList,
    selectedRowTreatmentList,
    handleOpenReceiveTreatment,
    handlePopupCancelTreatment,
    handleOpenUndoCompleteSingleTreatmentPopup,
  } = useStore().treatmentManagementStore.treatmentListAllStore;

  const canAssignTreatment = isAdmins || isRoleBranchManagers || isRoleCt;
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <TableComponent
          className=""
          showOrdinalNumbers
          titleNodata={t("noData")}
          selectType={!isReadonly ? "multi" : undefined}
          resetSelectedRows
          selectedRows={selectedRowTreatmentList}
          handleChangeSelectedRows={(selectedItems) => {
            setSelectedRowTreatmentList(selectedItems);
          }}
          showMoreButton
          name="TreatmentListAllData"
          data={pageTreatmentListAll?.content || []}
          minWidth={"720px"}
          columns={[
            !isReadonly && {
              title: t("action"),
              field: "action",
              align: "center",
              width: "30px",
              render: (row) => {
                const itemStatus = row?.itemStatus;

                return (
                  <div className="flex-center gap-2">
                    {canAssignTreatment &&
                      itemStatus ===
                      LAServiceRequestItemStatusEnum.NEW.value && (
                        <Tooltip
                          title="Cập nhật thông tin dịch vụ"
                          placement="top"
                          arrow
                        >
                          <IconButton
                            size="small"
                            className="actionButton"
                            onClick={() =>
                              handleOpenAllocationServicePopup(row?.id)
                            }
                          >
                            <AssignmentIcon
                              style={{
                                color: "#008693",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      )}

                    {itemStatus ===
                      LAServiceRequestItemStatusEnum.NEW.value && (
                        <>
                          {canAssignTreatment && (
                            <Tooltip
                              title="Tiếp nhận điều trị"
                              placement="top"
                              arrow
                            >
                              <IconButton
                                onClick={() => {
                                  handleOpenReceiveTreatment(row);
                                }}
                                size="small"
                                className="actionButton"
                              >
                                <AddToQueueIcon className="actionIcon" />
                              </IconButton>
                            </Tooltip>
                          )}
                          {isAdmins && (
                            <Tooltip
                              title="Xóa chỉ định dịch vụ"
                              placement="top"
                              arrow
                            >
                              <div
                                className="flex"
                                onClick={() =>
                                  handleDeleteNewServiceRequestItem(row)
                                }
                              >
                                <IconDelete />
                              </div>
                            </Tooltip>
                          )}
                        </>
                      )}

                    {canAssignTreatment &&
                      itemStatus ===
                      LAServiceRequestItemStatusEnum.RECEIVED.value && (
                        <>
                          <Tooltip title="Hủy điều trị" placement="top" arrow>
                            <IconButton
                              size="small"
                              className="primary"
                              onClick={() => {
                                handlePopupCancelTreatment(row);
                              }}
                            >
                              <CancelScheduleSendIcon
                                style={{
                                  color: "#008693",
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                          <Tooltip
                            title="Thông tin điều trị"
                            placement="top"
                            arrow
                          >
                            <IconButton
                              onClick={async () => {
                                try {
                                  let { data } =
                                    await getOrCreateNewByServiceRequestItemId(
                                      row?.id
                                    );
                                  if (data) {
                                    history.push(
                                      Config.ROOT_PATH +
                                      PathModule.TREATMENT_MANAGEMENT +
                                      `/treatment-update-results-detail/${row?.id}`
                                    );
                                  }
                                } catch (error) {
                                  toast.error(error);
                                }
                              }}
                              size="small"
                              className="actionButton"
                            >
                              <LocalHospitalIcon
                                style={{
                                  color: "red",
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}

                    {canAssignTreatment &&
                      itemStatus ===
                      LAServiceRequestItemStatusEnum.PROCESSING.value && (
                        <>
                          <Tooltip
                            title="Thông tin điều trị"
                            placement="top"
                            arrow
                          >
                            <IconButton
                              onClick={() => {
                                history.push(
                                  Config.ROOT_PATH +
                                  PathModule.TREATMENT_MANAGEMENT +
                                  `/treatment-update-results-detail/${row?.id}`
                                );
                              }}
                              size="small"
                              className="actionButton"
                            >
                              <LocalHospitalIcon
                                style={{
                                  color: "red",
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}

                    {canAssignTreatment &&
                      itemStatus ===
                      LAServiceRequestItemStatusEnum.FINISHED.value && (
                        <>
                          <Tooltip
                            title="Thông tin điều trị"
                            placement="top"
                            arrow
                          >
                            <IconButton
                              onClick={() => {
                                history.push(
                                  Config.ROOT_PATH +
                                  PathModule.TREATMENT_MANAGEMENT +
                                  `/treatment-update-results-detail/${row?.id}`
                                );
                              }}
                              size="small"
                              className="actionButton"
                            >
                              <LocalHospitalIcon
                                style={{
                                  color: "red",
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}

                    {canAssignTreatment &&
                      itemStatus ===
                      LAServiceRequestItemStatusEnum.FINISHED.value && (
                        <>
                          <Tooltip
                            title="Hủy hoàn thành điều trị"
                            placement="top"
                            arrow
                          >
                            <IconButton
                              onClick={() => {
                                handleOpenUndoCompleteSingleTreatmentPopup(row);
                              }}
                              size="small"
                              className="actionButton"
                            >
                              <CancelPresentationIcon
                                style={{
                                  color: "red",
                                }}
                                className="actionIcon"
                              />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}
                  </div>
                );
              },
            },

            {
              field: "displayName",
              title: t("Tên khách hàng"),
              render: (rowData) => (
                <div
                  style={{ cursor: hasPermission ? "pointer" : "default" }}
                  onClick={() => {
                    if (!hasPermission) return;
                    history.push(
                      `/treatment-management/treatment-patient-info-detail?patientId=${rowData?.encounter?.patient?.id}`
                    );
                  }}
                >
                  <Tooltip title="Thông tin khách hàng">
                    <div>
                      <p>
                        <b>{rowData?.encounter?.patient?.displayName}</b>
                      </p>
                      <p className="flex">
                        <span style={{ color: "#4276a4" }}>
                          <CopyableCodeCell
                            value={rowData?.encounter?.patient?.code}
                            size="small"
                          />{" "}
                        </span>
                        <p>
                          {rowData?.encounter?.patient?.gender && (
                            <>
                              {" "}
                              | {getGender(rowData?.encounter?.patient?.gender)}
                            </>
                          )}
                        </p>
                      </p>
                    </div>
                  </Tooltip>
                </div>
              ),
              fixed: true,
            },

            {
              field: "service.name",
              title: t("Dịch vụ"),
              render: (rowData) => {
                return (
                  <>
                    <div className="pl-1 pr-1">
                      <div>
                        <span className="service-code">
                          {rowData?.service?.code}
                        </span>{" "}
                        <span className="service-name">
                          {rowData?.service?.tradeName ||
                            rowData?.service?.name}
                        </span>
                      </div>

                      {rowData?.times && (
                        <span className="font-size-12">
                          {`Lần ${rowData?.treatmentType ===
                              SERVICE_TREATMENT_TYPE_WARRANTY
                              ? "bảo hành"
                              : "điều trị"
                            }: ${rowData?.times || 0} ${rowData?.unLimited
                              ? "(Không giới hạn)"
                              : "| " + (rowData?.totalTreatmentTimes || 0)
                            }`}
                        </span>
                      )}
                    </div>
                  </>
                );
              },
            },
            {
              field: "service.name",
              title: t("Dịch vụ bảo hành chi tiết"),
              render: (rowData) => {
                return (
                  <>
                    <div className="pl-1 pr-1">
                      <div>
                        <span className="service-name">
                          {rowData?.warrantyService}
                        </span>
                      </div>
                    </div>
                  </>
                );
              },
            },
            {
              field: "age",
              title: t("Ngày sinh"),
              render: (rowData) => renderBirthDate(rowData?.encounter?.patient),
            },

            // {
            //   field: "encounter.patient.phoneNumber",
            //   title: t("Số điện thoại"),
            // },

            {
              field: "department.name",
              title: t("Cơ sở"),
            },

            {
              field: "room.name",
              title: t("Phòng"),
            },

            {
              field: "assigner.staffName",
              title: t("Người chỉ định"),
            },

            {
              field: "encounterParticipants",
              title: t("Nhân viên tham gia"),
              render: (row) => {
                const names = row?.encounterParticipants
                  ?.map((ep) => {
                    const staffName = ep?.staff?.staffName;
                    const positionName = ep?.position?.name;
                    const isMains = ep?.isMain;
                    if (staffName && positionName) {
                      return `${positionName} - ${staffName} - ${isMains ? " ⭐" : ""
                        }`;
                    }
                    return staffName || positionName || "";
                  })
                  ?.filter(Boolean)
                  ?.join(", ");
                return names || "";
              },
            },

            {
              field: "orderDate",
              title: t("Thời gian chỉ định"),
              render: (val) => getDateTime(val?.orderDate),
            },

            {
              field: "receptionTime",
              title: t("Thời gian tiếp nhận"),
              render: (val) => getDateTime(val?.receptionTime),
            },

            {
              field: "performDate",
              title: t("Thời gian thực hiện"),
              render: (val) => getDateTime(val?.performDate),
            },

            {
              field: "itemStatus",
              title: t("Trạng thái"),
              render: (rowData) => {
                const status = rowData?.itemStatus;

                return (
                  <span>
                    {SERVICE_REQUEST_STATUS?.find(
                      (item) => item.value === status
                    )?.name || t("Chưa xác định")}
                  </span>
                );
              },
            },
            {
              field: "hasImg",
              title: t("Đã up ảnh"),
              align: "center",
              render: (row) => (row?.hasImg ? "✔️" : "❌"),
            },
            {
              field: "note",
              title: t("Ghi chú"),
            },
          ].filter(Boolean)}
          dataPagination={{
            pageIndex: searchTreatmentListAll.pageIndex,
            pageSize: searchTreatmentListAll.pageSize,
            totalElements: pageTreatmentListAll.totalElements,
            totalPages: pageTreatmentListAll.totalPages,
            setPageIndex: (pageIndex) => handleChangeFormSearch({ pageIndex }),
            setPageSize: (pageSize) => handleChangeFormSearch({ pageSize }),
          }}
        />
      </Grid>
    </Grid>
  );
};

export const renderBirthDate = (patient) => {
  let textBirthDate = "";
  if (patient?.birthDate) {
    textBirthDate += `${getDate(patient?.birthDate)} `;
  }
  if (patient?.age) {
    textBirthDate += `- ${getAge(patient?.birthDate)}`;
  }
  return textBirthDate;
};

export default observer(TreatmentListAllData);
